module.exports = __webpack_public_path__ + "assets/media/bolts-flipped.0d640091.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/bolts-flipped.svg
// module id = 114
// module chunks = 0